import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalComponent, TagIconComponent } from '@tecalisdev/infinity';

@Component({
	selector: 'app-modal-pending-documents',
	imports: [TranslatePipe, ModalComponent, TagIconComponent],
	templateUrl: './modal-pending-documents.component.html',
})
export class ModalPendingDocumentsComponent {
	@Input() isVisible: boolean = false;
	@Output() isVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	public closeModal(): void {
		this.isVisible = false;
		this.isVisibleChange.emit(false);
	}
}
